import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../context/LangContext";
import { translations } from "../../lib/i18n";
import { TEST_IDS } from "../../constants/testIds";

const Profile = ({ profileImage }) => {
  const { lang } = useLang();
  const t = translations[lang].profile;

  return (
    <section
      id="profile"
      data-testid={TEST_IDS.profile.root}
      className="rp-section bg-[color:var(--rp-bg-2)]"
    >
      <div className="rp-container grid grid-cols-12 gap-10 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="col-span-12 lg:col-span-6"
        >
          <div className="relative overflow-hidden border border-white/10">
            <img
              src={profileImage}
              alt="Robert Prieto — Goalkeeper Coach"
              className="w-full h-[520px] md:h-[640px] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />
            <div className="absolute bottom-5 left-5 flex items-center gap-2 text-[10px] tracking-[0.28em] uppercase text-white/70">
              <span className="w-1.5 h-1.5 bg-[color:var(--rp-accent)]" />
              On the pitch
            </div>
          </div>
        </motion.div>

        <div className="col-span-12 lg:col-span-6 lg:pt-4">
          <div className="rp-eyebrow mb-4">02 · {t.eyebrow}</div>
          <h2 className="rp-heading rp-headline mb-8">{t.title}</h2>
          <div className="space-y-6 text-[color:var(--rp-muted)] text-[15px] leading-[1.75] max-w-[58ch]">
            {t.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-3 gap-4">
            {t.pillars.map((p, i) => (
              <div
                key={p}
                className="border-t border-white/10 pt-4"
              >
                <div className="text-[color:var(--rp-accent)] font-display font-bold text-sm">
                  0{i + 1}
                </div>
                <div className="mt-2 font-display font-semibold text-white text-sm tracking-wider">
                  {p}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profile;
